import { useTranslation } from "react-i18next";
import styles from "./WarningBox.module.css";

export const WarningBox = () => {
  const { t } = useTranslation("myLoanInvoice");

  return (
    <div className={styles.warnBox}>
      <div className={styles.title}>{t("checkInvoice")}</div>
      <div className={styles.detail}>{t("checkInvoiceDetail")}</div>
    </div>
  );
};
